





































































import { Vue, Component, Prop } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { isMobileApp } from "@/shared/mobileHelper";
import { openUrl } from "@/shared/urlHelper";
import { shareUrl } from "@/shared/nativePlugins/share";
import { downloadFile } from "@/shared/nativePlugins/fileHelper";
import { printPdf } from "@/shared/nativePlugins/print";

@Component({
  components: {
    Button
  }
})
export default class FormDownload extends Vue {
  isDownloading = false;
  isPrinting = false;
  isSharing = false;
  formDownloaded = false;

  @Prop({ required: true })
  generateForm: () => Promise<any>;

  @Prop({ required: true })
  goToNextStep: () => void;

  @Prop({ required: true })
  goToPreviousStep: () => void;

  get downloadDisabled () {
    return this.isDownloading;
  }

  get printDisabled () {
    return this.isPrinting;
  }

  get shareDisabled () {
    return this.isSharing;
  }

  get nextDisabled () {
    return this.$validator.errors.any();
  }

  get showShareOptions () {
    return isMobileApp();
  }

  downloadForm () {
    this.isDownloading = true;
    this.formDownloaded = true;
    this.$validator.errors.clear();
    this.generateForm()
      .then(result => {
        this.handleDownload(result.downloadUrl);
        this.isDownloading = false;
      })
      .catch(() => {
        this.isDownloading = false;
      });
  }

 async handleDownload (url: string) {
    if (isMobileApp()) {
      await downloadFile({ url });
    } else {
      this.downloadFromUrl(url);
    }
  }

  downloadFromUrl (url: string) {
    const a = document.createElement("a");
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  printForm () {
    this.isPrinting = true;
    this.formDownloaded = true;
    this.$validator.errors.clear();
    this.generateForm()
      .then(result => {
        this.handlePrint(result.url);
        this.isPrinting = false;
      })
      .catch(() => {
        this.isPrinting = false;
      });
  }

  async handlePrint (url: string) {
    if (isMobileApp()) {
      await printPdf({ url, name: "Balance transfer form"});
    } else {
      openUrl(url);
    }
  }

  async shareForm () {
    this.isSharing = true;
    this.formDownloaded = true;
    this.$validator.errors.clear();
    this.generateForm()
    .then(result => {
      return shareUrl(result.url)
      .then(() => {
        this.isSharing = false;
      });
    }).catch(_ => {
      this.isSharing = false;
    });
  }

  onNext () {
    let message = "Please download or print the form before continuing.";
    if (this.showShareOptions) {
      message = "Please download, print or share the form before continuing.";
    }
    if (!this.formDownloaded) {
      this.$validator.errors.add({
        field: "formDownloaded",
        msg: message
      });

      return;
    }

    this.goToNextStep();
  }
}
